module.exports = __webpack_public_path__ + "4bcf55c5964fe91b49ee3e9a6b125d22.pdf";